import { ErrorMessage } from '@festina-life/components'
import { CircularSpinner } from '@festina-life/ui/feedback'
import type { FormikProps } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'
import { Icon } from '@festina-life/ui/structure'
import { useEffect, useRef, useState } from 'react'

import type { BranchCreationInput } from '../types'
import { useCreateBranch } from '../useCreateBranch'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const BranchCreationStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()
  const { mutateAsync, isPending } = useCreateBranch()
  const didTrigger = useRef(false)
  const [didSucceed, setDidSucceed] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!didTrigger.current) {
      didTrigger.current = true
      mutateAsync(values)
        .then(() => setDidSucceed(true))
        .catch(setError)
    }
  }, [mutateAsync, values])

  return (
    <div className="flex flex-col grow items-center justify-center">
      <ErrorMessage error={error} />
      {isPending && <CircularSpinner />}
      {!isPending && didSucceed && (
        <>
          <Icon
            name="CheckCircle"
            size="display"
            color="unset"
            className="text-success-500"
          />
          <p>
            {translate('branchCreationWizard.createStep.description', {
              branchName: values.branchName,
            })}
          </p>
        </>
      )}
    </div>
  )
}
